import { NavLink } from 'react-router-dom'

import { StyledLink } from 'components/v2/Link'
import { getShortId } from 'utils/string'

export const ChangeBookings = ({ bookings }: TSFixMe): TSFixMe => {
  const bookingIds = bookings.map(({ id }: TSFixMe): string => getShortId(id)).join(',')

  return (
    <div>
      {bookings.length > 0 ? (
        <div>
          <StyledLink as={NavLink} to={`/bookings?reservations=${bookingIds}`}>
            {bookings.length}
          </StyledLink>
        </div>
      ) : (
        0
      )}
    </div>
  )
}
